export interface CarrierSearchOption {
  label?: string | null;
  specialCoverage?: string | null;
}

export function orderCarriersBySearch<T extends CarrierSearchOption>(carriers: T[], searchText: string): T[] {
  const term = (searchText || '').trim().toLowerCase();
  if (!term) return carriers;

  const ranked = carriers.map((carrier, index) => ({
    carrier,
    index,
    rank: getCarrierSearchRank(carrier, term)
  }));
  const hasMatch = ranked.some((item) => item.rank < 3);

  if (!hasMatch) return carriers;

  return ranked
    .sort((a, b) => {
      const aSpecial = !!a.carrier.specialCoverage;
      const bSpecial = !!b.carrier.specialCoverage;
      if (aSpecial !== bSpecial) return aSpecial ? 1 : -1;
      const aOther = isOtherCarrier(a.carrier);
      const bOther = isOtherCarrier(b.carrier);
      if (aOther !== bOther) return aOther ? 1 : -1;
      if (a.rank !== b.rank) return a.rank - b.rank;
      return a.index - b.index;
    })
    .map((item) => item.carrier);
}

function isOtherCarrier(carrier: CarrierSearchOption): boolean {
  const label = (carrier.label || '').trim().toUpperCase();
  return label === 'OTHER' || label === 'OTHERS';
}

function getCarrierSearchRank(carrier: CarrierSearchOption, term: string): number {
  const label = (carrier.label || '').trim().toLowerCase();
  if (label === term) return 0;
  if (label.startsWith(term)) return 1;
  if (label.includes(term)) return 2;
  return 3;
}
